module.exports = __webpack_public_path__ + "img/709-f4c7af.png";